import { useFeature } from '@mafc/appshell';

const useNewC4Journey = () => {
  const newJourneyConfig = useFeature('new_carrefour_journey').value;
  return newJourneyConfig ? newJourneyConfig.new_journey : false;
};

export default useNewC4Journey;
